import { MobileLoginModalComponent } from "./../mobile-login-modal/mobile-login-modal.component";
import { LoginModal } from "./login.component";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

export function ShowLoginModal(
    modalService: NgbModal,
    loginError: boolean = false,
    cookieLogin: string,
    mobileMode = "desktop"
): Promise<any> {
    const mobile = mobileMode != "desktop";
    const component = mobile ? MobileLoginModalComponent : LoginModal;
    const windowClass = "dark-modal" + (mobile ? " mobile" : "");
    let m: NgbModalRef = modalService.open(component, {
        backdrop: "static",
        size: "sm",
        centered: true,
        windowClass: windowClass
    });
    let modal = <LoginModal>m.componentInstance;
    modal.loginError = loginError;

    console.log("SHOWLOGIN");
    console.log(cookieLogin);
    return m.result;
}
